import $axios from "../../api";

const state = () => ({
    isLoading: false,
    isErrors: "",
    page: 1,
    toolbarMenu: [],
});

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    ASSIGN_ERRORS(state, payload) {
        state.isErrors = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    ASSIGN_TOOLBAR_MENU(state, payload) {
        state.toolbarMenu = payload;
    },
};

const actions = {
    getListToolbarMenu({ commit, state, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`/toolbar`)
                .then((res) => {
                    commit("ASSIGN_TOOLBAR_MENU", res.data.data);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
